import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-sales-detail',
  standalone: false,
  
  templateUrl: './daily-sales-detail.component.html',
  styles: ``
})
export class DailySalesDetailComponent {

}
